import React from "react";

const VisorPdfContext = React.createContext();

export default VisorPdfContext;